import {html, css, LitElement} from 'lit';

export class DzPropertySpoiler extends LitElement {

    static properties = {
        opened:     {type: Boolean, reflect: true},
        changed:    {type: Boolean, reflect: true},
        selected:   {type: Boolean, reflect: true},
        name:       {type: String}
    }

    constructor() {
        super()
        this.opened   = false
        this.changed  = false
        this.selected = false
        this.name     = ""

        this.addEventListener("select", evt => {
            if (!evt.initial) {
                this.changed = true
            }
            this.selected = true
        })

        this.addEventListener("deselect", evt => {
            if (!evt.initial) {
                this.changed = true
            }
            if (evt.lastDeselect) {
                this.selected = false
            }
        })

        this.addEventListener("reset", evt => {
            let ms = this.querySelector("dz-multi-select")
            if (ms) {
                ms.reset()
                this.changed = true
            }
            if (evt) {
                evt.stopPropagation()
            }
        })
    }

    render() {
        let header = []
        header.push(html`<div>🢒</div>`)
        header.push(html`<span searchtext="property-spoiler" >${this.name}</span>`)
        if (this.changed) {
            header.push(html`
                <dz-custom-event name="apply">
                    <button class="spoiler-btn" >
                        <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 1.26174L5.77835 12L0 5.4L1.08354 4.13826L5.77835 9.46756L13.9165 0L15 1.26174Z" fill="#FF8A00"/>
                        </svg>
                    </button>
                </dz-custom-event>
            `)
        }

        if (this.selected) {
            header.push(html`
                <dz-custom-event name="reset">
                    <button class="spoiler-btn" >
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.4062 1.54679L10.3448 0.485352L6.13672 4.69345L1.92862 0.485352L0.867188 1.54679L5.07528 5.75488L0.867188 9.96298L1.92862 11.0244L6.13672 6.81632L10.3448 11.0244L11.4062 9.96298L7.19815 5.75488L11.4062 1.54679Z" fill="black"/>
                        </svg>
                    </button>
                </dz-custom-event> 
            `)
        }

        let layout = `grid-template-columns: 10px 1fr ${this.changed ? "30px" : ""} ${this.selected ? "20px" : ""}`

        return html`
            <div class="header" @click="${this.switchState}" searchitem="propery-spoiler" style="${layout}">
                ${header}
            </div>
            ${this.opened ? html`<slot name="body"></slot>` : ``}
        `
    }

    switchState() {
        if (this.opened) {
            this.opened = false
        } else {
            this.opened = true
        }
    }

    static styles = css`
        :host([opened]) > .header,
        :host(:last-child) > .header {
            border-bottom: none;
        }

        .header {
            box-sizing: border-box;
            padding: 10px;
            padding-right: 15px;
            display: grid;
            grid-template-columns: 10px 1fr;
            border-bottom: solid rgba(0, 0, 0, 0.05) 1px;
        }

        .spoiler-btn {
            display: flex;
            align-items: center;
            justify-content: right;
            appearance: none;
            border: none;
            background: none;
        }

        slot[name=body] {
            overflow: hidden;
            display: block;
        }
    `
}

customElements.define('dz-property-spoiler', DzPropertySpoiler)